import { gql, useApolloClient } from '@apollo/client'
import { useEffect, useState } from 'react'

const query = gql`
    query ProductStock($id: Int!) {
        product(id: $id) {
            id
            stockStatus
            onlyXLeftInStock
            lowestPrice
            outletAdviesprijs
            priceRange {
                maximumPrice {
                    discount {
                        amountOff
                        percentOff
                    }
                    finalPrice {
                        currency
                        value
                    }
                    regularPrice {
                        currency
                        value
                    }
                }
            }

            ... on ConfigurableProduct {
                variants {
                    attributes {
                        uid
                    }
                    product {
                        id
                        stockStatus
                        onlyXLeftInStock
                        lowestPrice
                        outletAdviesprijs
                        priceRange {
                            maximumPrice {
                                discount {
                                    amountOff
                                    percentOff
                                }
                                finalPrice {
                                    currency
                                    value
                                }
                                regularPrice {
                                    currency
                                    value
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

/**
 * Separately fetch stock and product price, so an up-to-date version will always be shown (albeit somewhat later)
 * @param productId
 */
export function useUncachedStock(productId: number) {
    const client = useApolloClient()

    useEffect(() => {
        client.query({
            query,
            variables: {
                id: productId,
            },
            fetchPolicy: 'network-only',
        })
    }, [client, productId])
}

const getProductQuery = gql`
    query ProductByUid($uid: ID!) {
        productByUid(uid: $uid) {
            id
        }
    }
`

export const useGetMinimalProductByUid = (productUid: string) => {
    const client = useApolloClient()

    const [hasError, setHasError] = useState<boolean>()

    useEffect(() => {
        ;(async () => {
            try {
                setHasError(false)
                await client.query({
                    query: getProductQuery,
                    variables: {
                        uid: productUid,
                    },
                })
            } catch (err) {
                setHasError(true)
            }
        })()
    }, [client, productUid])

    return hasError
}
